// Internal Imports
import {
  getApigatewayBaseUrl,
  getHostname,
  isBabbelHostname,
  isTrackingDisabled,
} from 'utils/url';
import {
  HOME,
  TERM_ARCHIVE,
  SEARCH_ARCHIVE,
  AUTHOR_ARCHIVE,
  CATEGORY_ARCHIVE,
  CONTENT_ITEM_SINGLE,
} from 'config/types/path';

export const pageType = {
  [HOME]: 'index',
  [AUTHOR_ARCHIVE]: 'author',
  [TERM_ARCHIVE]: 'tag',
  [CATEGORY_ARCHIVE]: 'category',
  [SEARCH_ARCHIVE]: 'search_results',
  [CONTENT_ITEM_SINGLE]: 'article',
};

const DEFAULT_EVENT_VERSION = 3;

const hasMobileTracker = () => Boolean(window?.MobileAppTracker);

const trackWithMobileTracker = ({ name, version, ...payload }) => {
  window.MobileAppTracker.track(name, version, JSON.stringify(payload));
  return Promise.resolve();
};

const trackWithEventsEndpoint = async (event) => {
  const apigateway_base_url = getApigatewayBaseUrl();
  const apiUrl = `${apigateway_base_url}/v1/events`;
  const postData = {
    events: [
      event,
    ],
  };
  const stringifiedPostData = JSON.stringify(postData);
  // Try sendBeacon() or fallback to fetch() if it's not supported
  // TODO: we could use fetch keepalive instead, but for now it's not supported in Firefox
  // once it is, we can get rid of `sendBeacon` fully and only use fetch with keepalive
  if ('function' === typeof navigator.sendBeacon) {
    try {
      if (navigator.sendBeacon(apiUrl, stringifiedPostData)) {
        return Promise.resolve();
      }
      // eslint-disable-next-line no-empty -- We want to ignore any errors happening here as we default to fetch later in the file
    } catch {}
  }

  return fetch(apiUrl, {
    body: stringifiedPostData,
    cache: 'no-store',
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  });
};

export async function trackPageEvent(eventPayload) {
  // We can't track events on heroku domain or locally
  // as tracking_uuid and uuid won't be available
  if (isTrackingDisabled || !isBabbelHostname(getHostname())) {
    return Promise.resolve();
  }
  const cookieMatch = document.cookie.match(/babbeltrackinguuid=([^;]+)/);
  const tracking_uuid = cookieMatch?.[1];
  try {
    const event = {
      created_at: (new Date()).toISOString(),
      ...(tracking_uuid ? { tracking_uuid } : {}),
      version: DEFAULT_EVENT_VERSION,
      ...eventPayload,
    };
    return hasMobileTracker() ? trackWithMobileTracker(event) : trackWithEventsEndpoint(event);
  } catch (exception) {
    return Promise.reject(exception);
  }
}
